import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnInit,
    ViewEncapsulation,
    inject,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { position: absolute; top: 0; bottom: 0; left: 0; right: 0; display: flex; flex-direction: column; justify-content: space-between; height: 100%; width: 100%; } :host .bazis-layout-press-footer__content { height: 100%; overflow: auto; }`,
);

@Component({
    selector: 'bazis-layout-press-footer',
    templateUrl: './layout-press-footer.component.html',
    // styleUrls: ['layout-press-footer.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LayoutPressFooterElement implements OnInit {
    public el = inject(ElementRef);

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
